import repoUrls from 'src/sections/repository/urls';

import {
  CONTAINERS_IMAGE_TAGS_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SEARCH_TAG_NAME_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from '../../constants';
import { ContainersImageTagsResponse } from '../../types';
import { buildPackagesApiQueryString } from '../../utils';
import { packagesResourceFactory } from '../utils';

export const containersImageTagsResource =
  packagesResourceFactory<ContainersImageTagsResponse>()({
    key: 'packages-container-tags',
    pathParamNames: ['packageName'] as const,
    queryParamNames: [
      PAGE_QUERY_PARAM,
      SORT_QUERY_PARAM,
      SEARCH_TAG_NAME_QUERY_PARAM,
    ] as const,
    getRequestUrl: (context, pathParams, queryParams) => {
      const queryString = buildPackagesApiQueryString({
        ...queryParams,
        // The API expects the image name in the query parameter.
        imageName: pathParams.packageName,
        [PAGELEN_QUERY_PARAM]: CONTAINERS_IMAGE_TAGS_PAGE_LENGTH.toString(),
      });

      switch (context.container) {
        case 'repository':
          return repoUrls.api.internal.containerImageTags(
            context.workspaceSlug,
            context.repositorySlug,
            queryString
          );
        default:
          throw new Error('Invalid route context');
      }
    },
  });
